import { stateDataIsStillValid, setMdg2EndpointData } from './Mdg2EndpointBaseModule.js';

const PRICES_LIST_RESPONSE_TO_LIVE = 60 * 1e3;
const CHUNK_SIZE = 99;
const getNotationData = () => (state) => (payload) => {
  var _a, _b;
  const key = [payload.id, payload.quality, payload.sameQuality].join("_");
  return (_b = (_a = state[key]) == null ? void 0 : _a.result) != null ? _b : void 0;
};
const fetchPricesListNotationData = (request, mdg2Client, logger) => async (store, payload) => {
  var _a, _b, _c;
  const ttl = (_a = request.ttl) != null ? _a : PRICES_LIST_RESPONSE_TO_LIVE;
  let status = true;
  try {
    const ids = payload.identifiers.filter((identifier) => {
      var _a2;
      const key = [identifier, payload.quality, payload.sameQuality].join("_");
      const expiresAt = (_a2 = store.state[key]) == null ? void 0 : _a2.expiresAt;
      return !expiresAt || !stateDataIsStillValid(expiresAt);
    });
    if (ids.length === 0) {
      return Promise.resolve(status);
    }
    const chunks = [];
    while (ids.length) {
      chunks.push(ids.splice(0, CHUNK_SIZE));
    }
    for (const chunk of chunks) {
      const url = typeof request.url === "function" ? request.url(payload) : request.url;
      const parameters = {
        identifiers: chunk,
        identifierType: payload.identifierType,
        quality: payload.quality,
        sameQuality: payload.sameQuality
      };
      logger.debug({
        mdg2Request: {
          type: request.method,
          url: request.url,
          payload: parameters
        }
      });
      const result = await mdg2Client.requestEndpoint(request.method, url, parameters, request.options, request.timeOutInMs);
      const statusCode = (_c = (_b = result.response.meta) == null ? void 0 : _b.status) == null ? void 0 : _c.code;
      if (!statusCode || statusCode < 200 || statusCode > 299) {
        throw new Error("Mdg2 request failed.");
      }
      result.response.data.forEach((priceData) => {
        const key = [priceData.sourceIdentifier, payload.quality, payload.sameQuality].join("_");
        store.commit("setEndpointData", {
          key,
          data: {
            result: { data: priceData, meta: result.response.meta },
            expiresAt: new Date().getTime() + ttl
          }
        });
      });
    }
  } catch (error) {
    logger.error(error);
    status = false;
  }
  return Promise.resolve(status);
};
const basePricesListMdg2EndpointModule = (request, mdg2Client, logger) => ({
  namespaced: true,
  state: {},
  getters: {
    getNotationData: getNotationData()
  },
  mutations: {
    setEndpointData: setMdg2EndpointData()
  },
  actions: {
    fetchEndpointData: fetchPricesListNotationData(request, mdg2Client, logger)
  }
});

export { basePricesListMdg2EndpointModule, fetchPricesListNotationData, getNotationData };
